;(function () {
  'use strict';

  const angular = window.angular;

  const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  ChangePasswordController.$inject = ['$scope', 'SuperAdmin', '$state', 'LoopBackAuth', 'AppUtils', '$rootScope'];

  angular
    .module('app')
    .component('publicChangePassword', {
      template:'<section class="login-container"><div class="login-header"><div class="login-brand"></div><h3 class="no-margin" translate>views.public.changePass.title</h3></div><div class="login-content"><form name="$ctrl.changePasswordForm" novalidate class="login-form validate" ng-submit="$ctrl.changePassword()" ng-if="!$ctrl.success"><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="$ctrl.changeForm.password" ng-change="$ctrl.onChange()" ng-blur="$ctrl.onBlur()" type="password" class="form-control" name="password" required ng-minlength="$ctrl.minPassLength" translate-attr="::{placeholder: \'entities._all.password\'}"></div><p ng-messages="$ctrl.changePasswordForm.password.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span> <span ng-message="minlength" translate>form.errors.minLength</span> <span ng-message="weak" translate>entities.user.password.weak</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="$ctrl.changeForm.repeatPassword" ng-change="$ctrl.onChange()" ng-blur="$ctrl.onBlur()" type="password" class="form-control" name="repeatPassword" required ng-minlength="$ctrl.minPassLength" translate-attr="::{placeholder: \'entities.user.password.confirm\'}"></div><p ng-messages="$ctrl.changePasswordForm.repeatPassword.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span> <span ng-message="minlength" translate>form.errors.minLength</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><ul class="list-unstyled marginB20" style="font-size: 12px"><li ng-class="$ctrl.requirements.length ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.length ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLength</span></li><li ng-class="$ctrl.requirements.upper ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.upper ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqUpper</span></li><li ng-class="$ctrl.requirements.lower ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.lower ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLower</span></li><li ng-class="$ctrl.requirements.digit ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.digit ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqDigit</span></li><li ng-class="$ctrl.requirements.symbol ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.symbol ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqSymbol</span></li></ul><button class="btn btn-login btn-lg btn-block" style="margin-top: 30px" translate>buttons.change</button></form><div ng-if="$ctrl.success" class="text-center"><h3 class="text-success"><i class="far fa-check-circle fa-fw fa-2x"></i> <strong style="display: block" class="marginTB10" translate>views.public.changePass.changedPass</strong></h3><p class="marginB20 paddingB20" translate>views.public.changePass.message</p></div><div class="text-center marginT20"><a ui-sref="public.login" translate>buttons.signin</a></div><div ng-if="$ctrl.error" class="alert alert-danger marginT20 marginB0 padding5 text-center">{{\'errors.\' + $ctrl.error | translate}}</div></div></section>',
      controller: ChangePasswordController,
      bindings: {
        $transition$: '<',
      }
    });

  function ChangePasswordController ($scope, SuperAdmin, $state, LoopBackAuth, utils, $root) {
    let vm = this;

    this.$onInit = function () {
      vm.changeForm = { password: '', repeatPassword: '' };
      vm.changePassword = changePassword;
      vm.minPassLength = 8;
      vm.requirements = { length: false, upper: false, lower: false, digit: false, symbol: false };

      vm.token = {
        userId: $state.params.uid,
        id: $state.params.token
      };

      LoopBackAuth.setUser(vm.token.id, vm.token.userId);
      LoopBackAuth.save();

      vm.onChange = onChange;
      vm.onBlur = onBlur;
    };

    function changePassword () {
      let password = vm.changeForm.password;
      let repeatPassword = vm.changeForm.repeatPassword;

      if (password && repeatPassword && password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      }

      vm.changePasswordForm.password.$setValidity('weak', STRONG_PASSWORD_REGEX.test(password || ''));

      $scope.$broadcast('show-errors-check-validity');

      if (!vm.changePasswordForm.$valid) {
        return;
      }

      $root.appReady = false;
      vm.success = false;
      vm.error = null;
      SuperAdmin
        .setPassword({ id: vm.token.userId, newPassword: password })
        .$promise
        .then(() => {
          $root.appReady = true;
          vm.success = true;
        })
        .catch(response => {
          $root.appReady = true;
          vm.error = utils.getHTTPError(response);
        });
    }

    function onChange () {
      let password = vm.changeForm.password || '';
      let repeatPassword = vm.changeForm.repeatPassword || '';

      vm.requirements.length = password.length >= vm.minPassLength;
      vm.requirements.upper = /[A-Z]/.test(password);
      vm.requirements.lower = /[a-z]/.test(password);
      vm.requirements.digit = /\d/.test(password);
      vm.requirements.symbol = /[^A-Za-z0-9]/.test(password);

      if (password.length < vm.minPassLength && repeatPassword.length < vm.minPassLength) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
    }

    function onBlur () {
      let password = vm.changeForm.password;
      let repeatPassword = vm.changeForm.repeatPassword;
      if (password && repeatPassword && password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      } else {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
    }
  }

})();
